import React, { ReactNode } from 'react';
import cn from 'classnames';
import ConfirmationPopover from '@mos-cat/confirmation-popover';
import { t } from '@lingui/macro';

import './ConfirmationPopovers.pcss';
import { i18n } from '../../../helpers/i18n';

export interface DeleteChildInfoPopoverProps {
  isPopoverOpen: boolean;
  wrapperClassName?: string;
  onPopoverClose?(): void;
  onConfirm?(): void;
  onCancel?(): void;
  children?: ReactNode;
}

function DeleteChildInfoPopover({
  children,
  isPopoverOpen,
  onPopoverClose,
  onConfirm,
  onCancel,
  wrapperClassName,
}: DeleteChildInfoPopoverProps): JSX.Element {
  return (
    <ConfirmationPopover
      floating
      isPopoverOpen={isPopoverOpen}
      title={i18n._(t`Удалить сведения?`)}
      description={i18n._(t`Сведения о ребёнке будут удалены безвозвратно`)}
      acceptText={i18n._(t`Удалить`)}
      cancelText={i18n._(t`Не удалять`)}
      className="DeleteChildInfoPopover"
      wrapperClassName={cn('DeleteChildInfoPopover_wrapper', wrapperClassName)}
      onPopoverClose={onPopoverClose}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      {children}
    </ConfirmationPopover>
  );
}

export default DeleteChildInfoPopover;
